import React from "react";
import Pagination from "react-js-pagination";
import UpgradeModal from "../../UpgradeModal/UpgradeModal";
import { isMobile, Activity, currentRequestTimeStamp } from "../../../Constants";
import { toast } from "react-toastify";
import classes from "../TrucksAvailable.module.css";

const EnquirySubmitFooter = ({
  send_data,
  validateUser,
  backbutton,
  discovernowbutton,
  planningbutton,
  skipactive,
  visible_enquiry,
  totalcount,
  getOnChange,
  closeButtonModal1,
  submitHandler,
  setsend_data,
  spotNoAccess,
  isRestricted,
}) => {
  return (
    <>
      {!isMobile() ? (
        <div className="w-100">
          <center
            className={`${discovernowbutton && planningbutton ? "s-enquiry" : ""} `}
            style={{ marginTop: "1%" }}
          >
            <center style={{ display: "contents" }}>
              {backbutton || discovernowbutton || planningbutton ? (
                <button
                  className="btn btn-sm btn-primary mr-5"
                  onClick={() => closeButtonModal1()}
                >
                  Back
                </button>
              ) : null}
            </center>
            {!backbutton &&
              !discovernowbutton &&
              !planningbutton &&
              send_data.length === 0 && (
                <Pagination
                  activePage={skipactive === 0 ? 1 : skipactive}
                  itemsCountPerPage={visible_enquiry}
                  totalItemsCount={totalcount}
                  onChange={(e) => getOnChange(e)}
                  itemClass="page-item"
                  linkClass="page-link"
                  hideDisabled
                />
              )}
            {send_data.length > 0 && (
              <>
                {validateUser === "basic" ? (
                  <UpgradeModal
                    screenName="LoRRI Spot"
                    moduleName="Upgrade Popup"
                    activityName="Submit button clicked"
                    buttonClass="btn btn-sm btn-success"
                    buttonLabel="Submit"
                    feature="Submit Enquiry"
                  />
                ) : backbutton || discovernowbutton || planningbutton ? (
                  <button
                    data-tut="reactour__submit"
                    style={{ marginLeft: "2%" }}
                    onClick={(e) => {
                      e.target.disabled = true;
                      submitHandler(e);
                    }}
                    className="btn btn-sm btn-success"
                    disabled={spotNoAccess || isRestricted}
                  >
                    Submit
                  </button>
                ) : (
                  <>
                    <button
                      onClick={(e) => {
                        e.target.disabled = true;
                        submitHandler(e);
                      }}
                      className={`btn btn-sm btn-success`}
                      disabled={spotNoAccess || isRestricted}
                    >
                      Submit
                    </button>
                    <button
                      className={`btn btn-sm btn-primary`}
                      style={{ margin: "0 1%" }}
                      onClick={(e) => {
                        Activity({
                          screen: "LoRRI Spot",
                          module: "LoRRI Spot",
                          user_activity: "Cancelled all enquiries",
                          timestamp: currentRequestTimeStamp(),
                        });
                        toast.success("Cancelled all enquiries");
                        setsend_data([]);
                      }}
                    >
                      Cancel
                    </button>
                  </>
                )}
              </>
            )}
          </center>
        </div>
      ) : (
        <>
          <div style={{ display: "flex", marginTop: "2%", marginLeft: "5%" }}>
            <center style={{ display: "contents" }}>
              {(backbutton || discovernowbutton || planningbutton) && (
                <button
                  className="btn btn-sm btn-primary"
                  style={{
                    marginRight: "10%",
                    marginLeft: "35%",
                    marginBottom: isMobile() ? "2%" : "",
                  }}
                  onClick={() => closeButtonModal1()}
                >
                  Back
                </button>
              )}
            </center>
          </div>
          <center>
            {send_data.length > 0 && (
              <>
                {validateUser === "basic" ? (
                  <UpgradeModal
                    screenName="LoRRI Spot"
                    moduleName="Upgrade Popup"
                    activityName="Submit button clicked"
                    buttonClass="btn btn-sm btn-success"
                    buttonLabel="Submit"
                    feature="Submit Enquiry"
                  />
                ) : backbutton || discovernowbutton || planningbutton ? (
                  <button
                    onClick={(e) => {
                      e.target.disabled = true;
                      submitHandler(e);
                    }}
                    className="btn btn-sm btn-success"
                    disabled={spotNoAccess || isRestricted}
                  >
                    Submit
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      e.target.disabled = true;
                      submitHandler(e);
                    }}
                    style={{ marginLeft: "4%" }}
                    className={`btn btn-sm btn-success ${classes["s-sub"]} `}
                    disabled={spotNoAccess || isRestricted}
                  >
                    Submit
                  </button>
                )}
              </>
            )}
            {send_data.length === 0 && (
              <Pagination
                activePage={skipactive === 0 ? 1 : skipactive}
                itemsCountPerPage={visible_enquiry}
                totalItemsCount={totalcount}
                onChange={(e) => getOnChange(e)}
                itemClass="page-item"
                linkClass="page-link"
                hideDisabled
              />
            )}
          </center>
        </>
      )}
    </>
  );
};

export default EnquirySubmitFooter;
